// extracted by mini-css-extract-plugin
export default {"container":"CircularProgressBar_container__15Kaw","circular-progress-bar":"CircularProgressBar_circular-progress-bar__yliXZ","progress":"CircularProgressBar_progress__4rhpB"};